import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ImageIcon from '@material-ui/icons/Image';
import React from 'react';
import { Box } from '../../UI';
import Carousel from '../../UI/Carousel';
import VideoCallIcon from '@material-ui/icons/VideoCall';

export default function ImageCarousel({ images }) {
	return (
		<Box mb="15px">
			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography variant="h6">
						<strong>Visuals</strong>
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Box display="flex" flexDirection="column" width='100%'>
						<Box display="flex" flexDirection="row" mb="0.5rem">
							<div style={{ marginRight: '0.5rem' }}>
								<input
									color="primary"
									accept="image/*"
									type="file"
									onChange={false}
									id="icon-button-file"
									style={{ display: 'none' }}
								/>
								<label htmlFor="icon-button-file">
									<Button
										variant="contained"
										component="span"
										color="primary"
										startIcon={<ImageIcon />}
									>
										Upload images
									</Button>
								</label>
							</div>
							<div style={{ marginRight: '0.5rem' }}>
								<input
									color="primary"
									accept="image/*"
									type="file"
									onChange={false}
									id="icon-button-file"
									style={{ display: 'none' }}
								/>
								<label htmlFor="icon-button-file">
									<Button
										variant="contained"
										component="span"
										color="primary"
										startIcon={<VideoCallIcon />}
									>
										Upload video
									</Button>
								</label>
							</div>
							{/* {images.length > 0 && (
								<Button
									variant="contained"
									component="span"
									size="large"
									color="primary"
									startIcon={<CancelIcon />}
								>
									Delete image
								</Button>
							)} */}
						</Box>
						<Box width="100%">
							<Carousel images={images} />
						</Box>
					</Box>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}
